import { exists } from '@/api'
import { dateToPlainFormat, plainToDateFormat } from '@/utils'

export interface LendUserMessage {
  userMemoId: number
  body: string
  userCheckedTime: string
  userMemoRevision: number
}

export function LendUserMessageFromJSON(json: any): LendUserMessage {
  return {
    userMemoId: exists(json, 'user_memo_id') ? json.user_memo_id : 0,
    body: exists(json, 'body') ? json.body : '',
    userCheckedTime: exists(json, 'user_checked_time')
      ? plainToDateFormat(dateToPlainFormat(json.user_checked_time))
      : '',
    userMemoRevision: exists(json, 'user_memo_revision')
      ? json.user_memo_revision
      : 0
  }
}
